// What the Scorecards weekly analysis panel shows for the AI write-up
// (GET /api/admin/reporting/scorecards/insights/writeup), kept apart from the
// panel so the rules are unit tested (ui/test/scorecardsWriteup.test.js).

// One team's write-up state: 'ready' (text to show), 'held' (the text held
// advice-style wording and was kept out), or 'none' (not written yet).
export function writeupViewFor(team, rows) {
  const row = (rows ?? []).find((r) => r.team === team)
  if (!row) return { kind: 'none', narrative: null, heldReason: null, generatedAt: null }
  if (row.status === 'ready' && row.narrative) return { kind: 'ready', narrative: row.narrative, heldReason: null, generatedAt: row.generatedAt ?? null }
  return { kind: 'held', narrative: null, heldReason: row.heldReason ?? null, generatedAt: row.generatedAt ?? null }
}

// True when a team had no email contacts this week or last (and no Support
// Email), the same test the server uses before it writes a team up
// (services/scorecards-writeup.js), so it never gets a paragraph.
export function hasNoActivity(teamOverTeam, team) {
  const o = (teamOverTeam ?? []).find((t) => t.team === team)
  if (!o) return false
  return (o.current?.contacts ?? 0) === 0 && (o.previousWeek?.contacts ?? 0) === 0 && (o.current?.supportEmailContacts ?? 0) === 0
}

// True when "Write it now" has something to write: some shown team has no row.
export function hasMissingWriteup(teams, rows) {
  return teams.some((t) => writeupViewFor(t, rows).kind === 'none')
}

// The numbers section: always shown while the write-up is off (nothing else on
// the panel), collapsed behind "Show the numbers" once it is on.
export function numbersStartOpen(writeupEnabled) {
  return !writeupEnabled
}

// "Written Mon 10/26, 7:00 AM" style stamp, Eastern, for the caption under a
// team's paragraph. Empty when unknown.
export function writtenStamp(generatedAt) {
  if (!generatedAt) return ''
  const d = new Date(generatedAt)
  if (Number.isNaN(d.getTime())) return ''
  return d.toLocaleString('en-US', { timeZone: 'America/New_York', weekday: 'short', month: 'numeric', day: 'numeric', hour: 'numeric', minute: '2-digit' })
}
